import {appEnv} from '../properties/UrlsAndEnvProperties';
import { APPCONFIG } from '../../config';
import { Base64 } from 'js-base64';

export function getLocalyticsAppKey() {
    let appKey = "";
    if(appEnv() == 'production') {
        if(APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_PROD === undefined || APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_PROD === null){
          appKey = "";
        }
        else{
          appKey = APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_PROD.toString();
        }
      }
      else {
        if(APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_DEV === undefined || APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_DEV === null){
          appKey = "";
        }
        else{
          appKey = APPCONFIG.REACT_APP_LOCALYTICS_APP_KEY_DEV.toString();
        }
      }
      const decodedKey = Base64.decode(appKey);
      return decodedKey;
}